import { isMobile, setFullWidthWrapper } from "./helper";
import SiteHeader from "./siteHeader";
import { toggleMenu, addSticky, closeMenu } from "./navigation";
import FloatLabels from "./forms/float-labels";

window.addEventListener("load", () => {
  const siteHeader = new SiteHeader();

  if (
    !document.querySelector("body").classList.contains("page-template-homepage")
  ) {
    siteHeader.setBodyPaddingTop();
  }
  new FloatLabels();

  toggleMenu();
  setFullWidthWrapper(
    document.querySelector(".single-realisations #flats-on-floor")
  );

  if (isMobile()) {
    siteHeader.addSticky();
    siteHeader.setBodyPaddingTop();
    closeMenu();
    addSticky();
  } else {
    siteHeader.stickyHeader();
  }
});

window.onresize = () => {
  if (isMobile()) {
    closeMenu();
    addSticky();
  }
};
